import React, { Component } from "react";
import { Link } from "react-router-dom";
import Header from "../../../assets/components/header";
import Footer from "../../../assets/components/footer";

class TeeTimeRequestReports extends Component {
    body() {
        return (
            <div className='container'>
                <div className='row'>
                    <div className='col'>
                        <h2>Tee Time Request Reports</h2>
                    </div>
                </div>

                <div className='row mt-3'>
                    <div className='col-md-12 mb-3'>
                        <Link
                            className='card text-decoration-none h-100'
                            to='/reports/tee-time-requests/bookings-by-hour'
                        >
                            <div className='card-body'>
                                <h3 className='card-title'>Bookings by Hour</h3>
                                <p className='card-text'>
                                    View tee-time requests grouped by the hour
                                    in which they were created.
                                </p>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <>
                <div className='d-flex main'>
                    <Header history={this.props.history} />
                    {this.body()}
                </div>
                <Footer />
            </>
        );
    }
}

export default TeeTimeRequestReports;
